module.exports = __webpack_public_path__ + "static/img/brees-2014-slide-8.25e7b15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2014-slide-8.jpg
// module id = 0cTc
// module chunks = 1